module.exports = __webpack_public_path__ + "static/head-of-pmo-thumbnail-9526b27e58f65f7fc8fa9f477804cf15.png";